export default __webpack_public_path__ + "static/media/woman.3c8b2168.jpg";